import React from 'react';
import { motion } from 'framer-motion';
const lines = ['Nadie te advirtió que el verdadero cansancio empieza después. Cuando todos se acomodan, la casa queda en silencio… y tú también desapareces.', 'El cuerpo cambió. Las prioridades cambiaron. Tu mente se siente como niebla. Y entre el trabajo, los hijos, la pareja y las cuentas, cada noche aparece la misma pregunta, sin falta:'];
export function PainSection() {
  return <section className="w-full bg-plum py-20 text-cream sm:py-28" aria-labelledby="pain-title" data-id="element-156" data-mp="2l6rjii5upg0n">
      <div className="mx-auto w-full max-w-3xl px-5 text-center sm:px-8" data-id="element-157" data-mp="2q0ncf679ccoy">
        <h2 id="pain-title" className="sr-only" data-id="element-158" data-mp="2baxysbhzag7s">
          Lo que estás sintiendo
        </h2>

        {lines.map((line, index) => <motion.p key={line} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6,
        delay: index * 0.12
      }} className="mb-7 text-lg leading-relaxed text-cream/80 sm:text-xl" data-id="element-159" data-mp="2g9iwo49rcnt2" data-mpi={index}>
            {line}
          </motion.p>)}

        <motion.p initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.6
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="my-10 font-display text-4xl italic leading-tight text-blush sm:text-5xl" data-id="element-160" data-mp="3nkw0em5ltxkj">
          «¿Y yo… dónde quedé?»
        </motion.p>

        <div className="mx-auto max-w-xl space-y-4 text-lg leading-relaxed text-cream/85 sm:text-xl" data-id="element-161" data-mp="33yhlr5d06hf3">
          <p data-id="element-162" data-mp="3ine17nhe2wpq">Esto no significa que estés mal.</p>
          <p className="font-display text-3xl text-cream sm:text-4xl" data-id="element-163" data-mp="3io5ped8nps5z">
            Significa que estás renaciendo.
          </p>
          <p data-id="element-164" data-mp="2q5i5301hih5y">Pero sin mapa. Sin tribu. Y sin permiso para decirlo en voz alta.</p>
          <p className="pt-4 font-medium text-cream" data-id="element-165" data-mp="2l6ymn9m3nnic">
            No estás sola. No estás rota. Solo nadie te enseñó a sostenerte a ti.
          </p>
        </div>
      </div>
    </section>;
}